import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLocale } from '../context/LocaleContext';
import './Checkout.css';

const CheckoutFailed = () => {
  const { t } = useTranslation();
  const { localePath } = useLocale();
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') || 'error';
  const orderId = searchParams.get('orderId');
  const isServiceOrder = searchParams.get('type') === 'service';
  const message = t(`checkoutReasons.${reason}`, { defaultValue: t('checkoutReasons.error') });

  return (
    <div className="checkout-page">
      <div className="checkout-wrap">
        <div className="checkout-not-found-card" style={{ border: '1px solid #fecaca' }}>
          <h2 style={{ color: '#b91c1c' }}>{t('checkout.failed')}</h2>
          <p style={{ color: '#64748b', marginBottom: '1.5rem' }}>{message}</p>
          <p style={{ fontSize: '0.9rem', color: '#94a3b8' }}>
            {t('checkout.supportHint')}
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap', marginTop: '1.5rem' }}>
            <Link to={localePath(isServiceOrder ? '/services' : '/products')} className="checkout-btn-primary">{isServiceOrder ? t('checkout.servicesBack') : t('checkout.storeBack')}</Link>
            {orderId && (
              <Link to={localePath(isServiceOrder ? `/user-panel/service-orders/${orderId}` : '/user-panel')} className="checkout-btn-primary" style={{ background: '#64748b' }}>{isServiceOrder ? t('checkout.serviceOrderBack') : t('checkout.myOrders')}</Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutFailed;
